import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingController } from '@ionic/angular';
import { IframeEventKeys } from '../constants/iframe-constants';
import { Store } from '@ngrx/store';
import { ActionReducerMapType } from '../store/config-reducers';
import { AuthService } from './auth.service';
import { AuthApi } from '../api/auth-api.service';

type IframeEventData = {
    eventKey: string;
    token?: string;
    alertMsg?: string;
    navigatePath?: string;
    accessToken?: string;
};

@Injectable({
    providedIn: 'root',
})
export class IframeListenerService {
    constructor(
        private router: Router,
        private loadingCtrl: LoadingController,
        private store: Store<ActionReducerMapType>,
        private authService: AuthService,
        private authApi: AuthApi,
        private zone: NgZone
    ) {}

    onDetectAuthentication = (event) => {
        // console.log('=============iframe-listener.service================');
        const eventData: IframeEventData = event.data;
        const eventKey = eventData?.eventKey;
        const portalToken = eventData?.token;
        // console.log('====> eventKey : ', eventKey);
        // console.log('====> portalToken : ', portalToken);
        if (eventKey === IframeEventKeys.VERIFY_TOKEN && portalToken) {
            console.log('====> Go-VerifyToken', portalToken);
            this.authService.processVerifyToken(portalToken);
        } else if (eventKey === IframeEventKeys.VERIFY_TOKEN && !portalToken) {
            console.log(
                '====> Go-RemoveEventListener : verifyToken + No Token'
            );
            window.removeEventListener(
                'message',
                this.onDetectAuthentication,
                false
            );
        } else if (eventKey === IframeEventKeys.CALLBACK_NO_TOKEN) {
            console.log('====> Call back no token : go login page');
            setTimeout(() => {
                this.authService.goToMainPage();
            }, 400)
        }
    };

    subscribe() {
        window.addEventListener('message', this.onDetectAuthentication, false);
    }
}
